import { Component, Input, OnInit } from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'
import { Datum } from 'src/app/models/common/datum'
import { Level } from 'src/app/models/slat/slat-levels-dto'

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  standalone: false,
})
export class DropdownComponent implements OnInit {
  @Input() control: FormControl
  @Input() data: Datum[] | Level[]
  @Input() label: string
  @Input() required: boolean = false
  @Input() errorText: string
  @Input() isCustom: boolean = false
  id: string

  selectedValue: string

  ngOnInit(): void {
    this.id = LabelToId(this.label)
  }

  identify(index: any, item: any) {
    return item.label
  }
}
